import { render, staticRenderFns } from "./CompanyUserDetailPage.vue?vue&type=template&id=49b3c370&scoped=true"
import script from "./CompanyUserDetailPage.vue?vue&type=script&lang=js"
export * from "./CompanyUserDetailPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyUserDetailPage.vue?vue&type=style&index=0&id=49b3c370&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b3c370",
  null
  
)

export default component.exports